<ng-container *ngIf="route.params | async as params">
  <ng-container *ngIf="params[RouteParam.Id] as id">
    <ng-container *ngIf="params[RouteParam.Dataset] as dataset">
      <app-freewall-editor actionLabel=" Save" [recordId]="id" [dataset]="dataset"
        (datasetChange)="onDatasetChange(id, $event)">
      </app-freewall-editor>
    </ng-container>
    </ng-container>
    </ng-container>
